module.exports = __webpack_public_path__ + "img/product-shot_04_loading.0037007a.jpg";